import type { ContextMenuConfig } from '@milanote/roma';
import type { ElementContextMenuContext, MobileElementContextMenuActions } from '../context/elementContextMenuContext';
import { ELEMENT_CONTEXT_MENU_ITEMS, getSelectedElementDetailItems } from '../items/elementContextMenuItems';
import { elementMetadataMenuItems } from '../items/elementMetadataMenuItems';

const items = ELEMENT_CONTEXT_MENU_ITEMS;

export const elementDesktopMenuConfig: ContextMenuConfig<ElementContextMenuContext> = [
    { id: 'board-navigation', items: [items.openInNewTab] },
    {
        id: 'clipboard',
        items: [
            items.paste,
            items.cut,
            items.copy,
            items.pasteStyles,
            items.duplicateAlias,
            items.duplicate,
            items.duplicateLinkedBoard,
            items.clone,
            items.moveToTrash,
        ],
    },
    { id: 'naming', items: [items.rename, items.createShortcut] },
    {
        id: 'media',
        items: [items.replaceImage, items.addImage, items.downloadOriginal, items.imageAspectRatio],
    },
    { id: 'links-and-files', items: [items.openFile, items.copyLink] },
    { id: 'drawing-download', items: [items.downloadSvg] },
    { id: 'grouping', items: [items.groupIntoColumn] },
    { id: 'connections', items: [items.connectWithLines] },
    { id: 'sketch-conversion', items: [items.convertToSketch] },
    { id: 'lock', items: [items.toggleLock] },
    { id: 'arrangement', items: [items.bringToFront, items.sendToBack] },
    { id: 'template', items: [items.convertToTemplate, items.revertTemplateToBoard] },
    {
        id: 'conversion',
        items: [items.convertToNote, items.convertToDocument, items.convertColumnToBoard],
    },
    { id: 'development', items: getSelectedElementDetailItems },
    { id: 'metadata', items: elementMetadataMenuItems },
];

export const elementMobileMenuConfig: ContextMenuConfig<ElementContextMenuContext<MobileElementContextMenuActions>> = [
    {
        id: 'mobile-clipboard',
        items: [items.cut, items.copy, items.copyLink, items.duplicate, items.groupIntoColumn],
    },
    {
        id: 'mobile-lock',
        items: [items.toggleLock],
    },
    {
        id: 'mobile-arrangement',
        items: [items.bringToFront, items.sendToBack],
    },
    {
        id: 'mobile-delete',
        items: [items.moveToTrash],
    },
];
